import AF from '../utlis/AF';

const CLASS_ACTIVE = 'is-profiles-active';

class Profiles {
    constructor(element) {
        this.el = element;
        if (!this.el) return; // Guard clause if the element is not provided
        
        this.af = AF.instance();
        this.button = this.el.querySelector('[profiles-button]');
        this.activate = this.activate.bind(this);

        this.init();
    }

    // Initialization logic, including event listener
    init() {
        if (this.button) {
            this.button.addEventListener('click', this.activate);
        }
    }

    // Cleanup event listener when no longer needed
    destroy() {
        if (this.button) {
            this.button.removeEventListener('click', this.activate);
        }
    }

    // The activate method that adds the active class
    activate() {
        this.af.onNextWrite(() => {
            this.el.classList.add(CLASS_ACTIVE);
        });
    }
}

export default Profiles;
